import {observer} from "mobx-react"
import React, {Component, Fragment} from "react"
import PropTypes from "prop-types"
import {Table} from "semantic-ui-react"
import Price from "components/Price/Price"
import _ from "lodash"
import { Link } from "react-router-dom"
import Responsive                                                from "react-responsive"

@observer
export default class ProductTableReadOnly extends Component {
	static propTypes = {
		list    : PropTypes.object,
		cart    : PropTypes.object,
		onChange: PropTypes.func,
		products: PropTypes.array,
		minimal : PropTypes.bool
	}

	constructor() {
		super()
	}

	render() {
		let {list, cart, products, onChange, minimal, showTax} = this.props
		let positions = list || products
		if ( list ) positions = list.products
		let rows = _.map( positions, ( product, index ) => {
			return (
				<ProductRow showTax={showTax} minimal={minimal} key={index} index={index} onChange={onChange} list={list} cart={cart} product={product} />
			)
		} )
		return (
			<Fragment>
				<Responsive minWidth={790}>
					<Table>
					<colgroup>
						<col width="5%" />
						<col width="40%" />
						<col width="" />
						<col width="5%" />
						<col width="10%" />
						<col width="10%" />
					</colgroup>
					<thead>
					<tr>
					<th>&nbsp;</th>
						<th>{translate("Artikel")}</th>
						{!minimal && <th>{translate("Preis/VE")}</th>}
						<th>{translate( "VE" )}</th>
						<th>{translate( "Menge" )}</th>
						{showTax && <th>{translate( "Steuer" )}</th>}
						<th className="tr">
							<div className="tr">{translate( "Summe" )}</div>
						</th>
					</tr>
					</thead>
					<tbody>
					{rows}
					</tbody>
					</Table>
				</Responsive>
				<Responsive maxWidth={790}>
				<table>

					<tbody>
					{rows}
					</tbody>
					</table>
				</Responsive>
			</Fragment>

		)
	}
}

const ProductRow = ( {product, minimal, showTax} ) => {
	return (
		<Fragment>
			<Responsive minWidth={790}>
				<tr>
				<td>
							<img
								className="db center"
								src={product.img_src_small}
								alt=""/>
					</td>   
				<td>
					<strong>{product.article_nr}</strong>
					<div><span className="product-title"><span className="nowrap">{product.title}</span></span></div>
				</td>
				{!minimal && <td>
			<Price>{product.price}</Price>
			<div className="flex flex-row">
			{product.pinfos.gc_rabatt && <a title={translate( "Coupon-Rabatt" )} className="labelNeu1">&nbsp;&nbsp;{translate("Coupon:")} {product.pinfos.gc_rabatt} %&nbsp;&nbsp;</a>}
			{product.isSale && product.pinfos.sale_percent && <a className="labelNeu1">&nbsp;&nbsp;{translate("Sale!")}&nbsp;&nbsp;</a>}
			</div>
		</td>}
				<td>
					<div className={"nowrap"}>{product.unit_multi} {translate( "Stück" )}</div>
				</td>
				<td>
					<div className={"nowrap"}>{product.count} {translate( "VE" )}</div>
				</td>
				{showTax && <td>
					<div><Price>{product.price * product.count * product.unit_multi * product.taxRate}</Price></div>
					<div className={"black-60"}>{product.taxRate * 100} %</div>
				</td>}
				<td className="tr">
					<div className="tr"><Price>{product.price * product.count * product.unit_multi}</Price></div>
				</td>
			</tr>
			</Responsive>

			<Responsive maxWidth={790}>
			<tr>


				<td>
				<Link to={`/product/${product.map_id}`}>
					<strong>{product.article_nr}</strong> <br/>
					<span className="product-title">{product.title}</span>
				</Link>
				</td><td>
							<img
								className="db center"
								height="34"
								width={70}
								src={product.img_src_small}
								alt=""/>
					</td>   
				<td>

				<div className="tr">
					<div><Price>{product.price * product.count * product.unit_multi}</Price></div>
					<div>{product.unit_multi * product.count} {translate( "Stück" )}</div>
				</div>
				</td>

				</tr>
			</Responsive>
		</Fragment>
	)
}

ProductRow.propTypes = {
	index   : PropTypes.any,
	list    : PropTypes.object,
	cart    : PropTypes.object,
	onChange: PropTypes.func,
	product : PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/theme/lindt/components/Product/ProductTableReadOnly.js